import { NumberSymbol } from "@angular/common";

export class FormField<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  validator: string;
  controlType: string;
  type: string;
  options: { key: string; value: string }[];
  order: number;

  constructor(
    options: {
      value?: T;
      key?: string;
      label?: string;
      required?: boolean;
      validator?: string;
      controlType?: string;
      type?: string;
      options?: { key: string; value: string }[];
      order?: number;
    } = {}
  )
  {
    this.value = options.value;
    this.key = options.key || "";
    this.label = options.label || "";
    this.required = !!options.required;
    this.validator = options.validator || "";
    this.controlType = options.controlType || "";
    this.type = options.type || "";
    this.options = options.options || [];
    this.order = options.order || 0;
  }
}
